<div class="page-container">
  <div class="top-spacer"></div>

  @if (isUpdate && (loading$ | async)) {
    <div class="mat-elevation-z1 shimmer-container">
      @for (_ of [].constructor(10); track _) {
        <div class="stencil-shimmer shimmer"></div>
      }
    </div>
  }

  @if (!isUpdate || (loading$ | async) === false) {
    <mat-expansion-panel class="settings-card" expanded="true">
      <mat-expansion-panel-header class="expansion-header">
        @if ((isSessionEventType$ | async) === false) {
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.TITLE' | translate }}
          </mat-panel-title>
        }
        @if ((isSessionEventType$ | async) === true && !showScheduleAccordion) {
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.SESSION_EVENT_TYPE_TITLE' | translate }}
          </mat-panel-title>
        }
        @if ((isSessionEventType$ | async) === true && showScheduleAccordion) {
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.SCHEDULE_SESSION_TITLE' | translate }}
          </mat-panel-title>
        }
        <mat-panel-description class="settings-card-description">
          {{ aboutCardDescription }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <form [formGroup]="form">
        <!-- Name field - Static display for schedule flow, editable for regular flow -->
        @if (showScheduleAccordion) {
          <div class="static-field">
            <span class="field-label"
              >{{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.NAME' | translate }}:&nbsp;</span
            >
            <span class="field-value">{{ eventTypeName }}</span>
          </div>
        }
        @if (!showScheduleAccordion) {
          <glxy-form-field>
            <glxy-label>
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.NAME' | translate }}
            </glxy-label>
            <input matInput required formControlName="name" />
            @if (nameControl.invalid && (nameControl?.dirty || nameControl?.touched)) {
              <glxy-error>
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.NAME_VALIDATION_REQUIRED' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
        }
        @if ((isSessionEventType$ | async) === true) {
          <glxy-form-field>
            <glxy-label>
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.SESSION_TITLE' | translate }}
            </glxy-label>
            <input matInput required formControlName="sessionTitle" />
            @if (sessionTitleControl.invalid && (sessionTitleControl?.dirty || sessionTitleControl?.touched)) {
              <glxy-error>
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.SESSION_TITLE_VALIDATION_REQUIRED' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
        }
        @if ((isSessionEventType$ | async) === false) {
          <glxy-form-field [prefixText]="linkPrefix$ | async">
            <glxy-label>
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LINK_LABEL' | translate }}
            </glxy-label>
            <input matInput required formControlName="slug" />
            @if (slugChanged) {
              <button mat-icon-button matSuffix (click)="revertSlug()">
                <mat-icon>undo</mat-icon>
              </button>
            }
            @if (slugControl.invalid && (slugControl?.dirty || slugControl?.touched)) {
              <glxy-error>
                {{ getSlugValidationError() }}
              </glxy-error>
            }
          </glxy-form-field>
        }
        <!--   Select meeting type & location   -->
        <div>
          <glxy-form-field>
            <glxy-label>
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION_LABEL' | translate }}
            </glxy-label>
            <mat-select formControlName="meetingLocation">
              <mat-option value="video"
                >{{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION.VIDEO' | translate }}
              </mat-option>
              <mat-option value="inPerson"
                >{{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION.IN_PERSON_MEETING' | translate }}
              </mat-option>
            </mat-select>
          </glxy-form-field>
          @if (meetingLocationControl.value === 'inPerson') {
            <mat-card class="location-card">
              <mat-card-content>
                @if ((isSessionEventType$ | async) === false) {
                  <glxy-form-field>
                    <glxy-label style="font-weight: bold">
                      {{
                        'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION.IN_PERSON.SET_LOCATION_LABEL' | translate
                      }}
                    </glxy-label>
                    <mat-radio-group layout="row" formControlName="radioSelection" class="radio-group">
                      <mat-radio-button value="userSite" class="radio-option">
                        {{
                          'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION.IN_PERSON.USER_SITE_MEETING_LABEL'
                            | translate
                        }}
                      </mat-radio-button>
                      <mat-radio-button value="clientSite" class="radio-option">
                        {{
                          'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION.IN_PERSON.CLIENT_SITE_MEETING_LABEL'
                            | translate
                        }}
                      </mat-radio-button>
                    </mat-radio-group>
                  </glxy-form-field>
                }
                @if (radioSelectionControl.value === 'userSite' || (isSessionEventType$ | async) === true) {
                  <glxy-form-field appearance="outline" class="fullwidth">
                    <glxy-label>
                      {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.IN_PERSON_MEETING_INPUT_FIELD' | translate }}
                    </glxy-label>
                    <textarea
                      matAutosizeMinRows="4"
                      matInput
                      matTextareaAutosize
                      formControlName="inPersonAddress"
                      [placeholder]="
                        'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.IN_PERSON_MEETING_PLACEHOLDER' | translate
                      "
                    ></textarea>
                  </glxy-form-field>
                }
                @if (radioSelectionControl.value === 'clientSite') {
                  <glxy-form-field appearance="outline" class="fullwidth">
                    <glxy-label>
                      {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.CLIENT_SITE_MEETING_INPUT_FIELD' | translate }}
                    </glxy-label>
                    <textarea
                      matInput
                      matTextareaAutosize
                      matAutosizeMinRows="4"
                      formControlName="locationGuidelines"
                      maxlength="200"
                      [placeholder]="
                        'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.CLIENT_SITE_MEETING_PLACEHOLDER' | translate
                      "
                    ></textarea>
                    <mat-hint align="end">{{ locationGuidelinesControl?.value?.length || 0 }}/200</mat-hint>
                  </glxy-form-field>
                }
                @if (radioSelectionControl.value === 'clientSite' || radioSelectionControl.value === 'userSite') {
                  <glxy-form-field appearance="outline" class="fullwidth">
                    <div class="toggle-space">
                      <mat-slide-toggle formControlName="isVideoLinkRequired">
                        <div class="slider-text">
                          {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION.HYBRID_INPUT_FIELD' | translate }}
                        </div>
                      </mat-slide-toggle>
                    </div>
                  </glxy-form-field>
                }
              </mat-card-content>
            </mat-card>
          }
          <glxy-form-field>
            <glxy-label>
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.DURATION_LABEL' | translate }}
            </glxy-label>
          </glxy-form-field>
          <mat-button-toggle-group class="duration-container" formControlName="durationSelection">
            @for (duration of durations; track duration) {
              <mat-button-toggle class="duration" [value]="duration">
                {{ duration }}
              </mat-button-toggle>
            }
            <mat-button-toggle class="duration" [value]="customDuration">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.CUSTOM_DURATION' | translate }}
            </mat-button-toggle>
          </mat-button-toggle-group>
          @if (
            durationSelectionControl.invalid && (durationSelectionControl?.dirty || durationSelectionControl?.touched)
          ) {
            <glxy-error>
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.DURATION_SELECTION_REQUIRED' | translate }}
            </glxy-error>
          }
          @if (isCustomDuration) {
            <glxy-form-field appearance="outline" class="fullwidth custom-duration">
              <glxy-label>
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.CUSTOM_DURATION_INPUT' | translate }}
              </glxy-label>
              <input matInput formControlName="durationInput" />
            </glxy-form-field>
          }
        </div>
        <glxy-form-field appearance="outline" class="fullwidth">
          <glxy-label>
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.DESCRIPTION' | translate }}
          </glxy-label>
          <textarea matAutosizeMinRows="4" matInput matTextareaAutosize formControlName="description"></textarea>
        </glxy-form-field>
        @if ((isSessionEventType$ | async) === false) {
          <glxy-form-field>
            <glxy-label>
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.COLOR_LABEL' | translate }}
            </glxy-label>
          </glxy-form-field>
        }
        @if ((isSessionEventType$ | async) === false) {
          <div class="color-container">
            @for (color of colors; track color) {
              <button
                mat-mini-fab
                class="color-selector"
                [ngStyle]="{ 'background-color': color }"
                (click)="setColor(color)"
              >
                @if (color === colorControl.value) {
                  <mat-icon>check</mat-icon>
                }
              </button>
            }
          </div>
        }
        @if ((isSessionEventType$ | async) === true) {
          <glxy-form-field>
            <glxy-label>
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.MAX_ATTENDEES' | translate }}
            </glxy-label>
            <input
              matInput
              required
              type="number"
              formControlName="maxAttendees"
              min="1"
              max="100"
              (wheel)="$event.preventDefault()"
            />
            @if (maxAttendeesControl.invalid && (maxAttendeesControl?.dirty || maxAttendeesControl?.touched)) {
              <glxy-error>
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.MAXIMUM_ATTENDEES_VALIDATION_REQUIRED' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
        }
      </form>
    </mat-expansion-panel>
  }

  <!-- Registration Cutoff Section (Session Event Types Only) -->
  @if (
    (!isUpdate || (loading$ | async) === false) && ((isSessionEventType$ | async) === true || showScheduleAccordion)
  ) {
    <mat-expansion-panel class="settings-card day-card" expanded="false">
      <mat-expansion-panel-header class="expansion-header">
        <div class="title-description">
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.REGISTRATION_CUTOFF.TITLE' | translate }}
          </mat-panel-title>
          <mat-panel-description class="availability-card-description">
            {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.REGISTRATION_CUTOFF.PROMPT' | translate }}
          </mat-panel-description>
        </div>
      </mat-expansion-panel-header>
      <form [formGroup]="form" class="form-class">
        <div class="mat-expansion-panel-body">
          <div class="range-type-section">
            <div class="range-type-group">
              <div class="radio-option">
                <div class="radio-button">
                  <div class="controls-inline">
                    <glxy-form-field class="value-field" hideRequiredLabel="true">
                      <input
                        matInput
                        type="number"
                        formControlName="registrationCutoffValue"
                        [min]="0"
                        class="relative-input"
                      />
                      @if (
                        registrationCutoffValueControl.invalid &&
                        (registrationCutoffValueControl?.dirty || registrationCutoffValueControl?.touched)
                      ) {
                        <glxy-error>
                          {{ 'MEETING_SCHEDULER.BOOKING_LINK.REGISTRATION_CUTOFF_VALIDATION_REQUIRED' | translate }}
                        </glxy-error>
                      }
                    </glxy-form-field>
                    <glxy-form-field class="unit-field" hideRequiredLabel="true">
                      <mat-select formControlName="registrationCutoffUnit" class="unit-select">
                        @for (unit of cutoffUnits; track unit) {
                          <mat-option [value]="unit.value">
                            {{ unit.label }}
                          </mat-option>
                        }
                      </mat-select>
                    </glxy-form-field>
                    <span class="suffix-text">{{
                      'MEETING_SCHEDULER.SCHEDULE_SETTINGS.REGISTRATION_CUTOFF.SUFFIX' | translate
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
  }

  @if ((!isUpdate || (loading$ | async) === false) && showScheduleAccordion) {
    <mat-expansion-panel class="settings-card day-card" expanded="true">
      <mat-expansion-panel-header class="expansion-header">
        <div class="title-description">
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.SESSION.DATE_RANGE.TITLE' | translate }}
          </mat-panel-title>
          <mat-panel-description class="availability-card-description">
            {{ 'MEETING_SCHEDULER.SESSION.DATE_RANGE.DESCRIPTION' | translate }}
          </mat-panel-description>
        </div>
      </mat-expansion-panel-header>
      <div class="settings-card-content">
        <form [formGroup]="form" class="form-class">
          <div class="date-time-inputs">
            <div class="date-time-input-width">
              <!-- Label is intentionally empty to avoid default the lable(date) -->
              <meeting-scheduler-calendar-date-picker
                [config]="calendarConfig"
                [selectedDate]="selectedDate"
                [label]="''"
                [placeholder]="'MEETING_SCHEDULER.SESSION.DATE_TIME.DATE.PLACEHOLDER'"
                [isSession]="isSessionEvent"
                [userIDs]="hostUserIds"
                (dateChange)="onDateChange($event)"
                (availableTimeSlotsChange)="onAvailableTimeSlotsChange($event)"
              ></meeting-scheduler-calendar-date-picker>
            </div>
            <div class="date-time-input-width">
              <glxy-form-field>
                <mat-select
                  placeholder="{{ 'MEETING_SCHEDULER.SESSION.DATE_TIME.TIME.PLACEHOLDER' | translate }}"
                  formControlName="selectedTime"
                >
                  @for (slot of availableTimeSlots; track slot) {
                    <mat-option [value]="slot"> {{ slot }} </mat-option>
                  }
                </mat-select>
                @if (selectedTimeControl.invalid && (selectedTimeControl?.dirty || selectedTimeControl?.touched)) {
                  <glxy-error>
                    {{ 'MEETING_SCHEDULER.BOOKING_LINK.TIME_VALIDATION_REQUIRED' | translate }}
                  </glxy-error>
                }
              </glxy-form-field>
            </div>
          </div>
        </form>
      </div>
    </mat-expansion-panel>
  }

  @if (
    ((showHostUserSection$ | async) === true || (isSessionEventType$ | async) === true) &&
    (!isUpdate || (loading$ | async) === false)
  ) {
    <mat-expansion-panel #teamMemberSection data-testid="team-member-section" class="settings-card" expanded="true">
      <mat-expansion-panel-header class="expansion-header">
        @if ((isSessionEventType$ | async) === false) {
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBER.TITLE' | translate }}
          </mat-panel-title>
        }
        @if ((isSessionEventType$ | async) === true) {
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.SESSION_TEAM_MEMBER.TITLE' | translate }}
          </mat-panel-title>
        }
      </mat-expansion-panel-header>
      <form [formGroup]="form" class="team-member">
        @if ((isSessionEventType$ | async) === false) {
          <div>
            <mat-radio-group formControlName="radioChoice" class="radio-group">
              <mat-radio-button [value]="TeamEventMeetingType.ROUND_ROBIN">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.ROUND_ROBING_LABEL' | translate }}
              </mat-radio-button>
              @if (featurePriorityAssignmentEnabled$ | async) {
                <mat-radio-button [value]="TeamEventMeetingType.PRIORITY_ROUND_ROBIN">
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.PRIORITY_ASSIGNMENT_LABEL' | translate }}
                </mat-radio-button>
              }
              <mat-radio-button [value]="TeamEventMeetingType.CLIENT_CHOICE">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.CLIENT_SELECTION_LABEL' | translate }}
              </mat-radio-button>
              <mat-radio-button [value]="TeamEventMeetingType.MULTI_HOST">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.MULTI_HOST_LABEL' | translate }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        }
        <div class="selection-container">
          @if (
            (isSessionEventType$ | async) === false && radioChoiceValue !== TeamEventMeetingType.PRIORITY_ROUND_ROBIN
          ) {
            <div class="selection-text">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBER.SELECTION' | translate }}
            </div>
          }
          @if (
            (isSessionEventType$ | async) === false && radioChoiceValue === TeamEventMeetingType.PRIORITY_ROUND_ROBIN
          ) {
            <div class="selection-text">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBER.PRIORITY_SELECTION' | translate }}
            </div>
          }
          @if ((isSessionEventType$ | async) === true) {
            <div class="selection-text">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.SESSION_TEAM_MEMBER.SELECTION' | translate }}
            </div>
          }
        </div>
        <div class="parent-container">
          <glxy-form-field>
            <mat-chip-grid #teamMemberChipGrid aria-label="Team Member selection">
              @for (teamMember of selectedTeamMembers; track teamMember; let i = $index) {
                @if (hostUserIds?.includes(teamMember.userId)) {
                  <mat-chip-row (removed)="removeTeamMember(i)">
                    <div class="team-member-list">
                      <span>
                        {{ teamMember.displayName | titlecase }}
                      </span>
                      @if (!teamMember.isConfigured || !teamMember.isConnected) {
                        <mat-icon class="warn-icon">warning</mat-icon>
                      }
                    </div>
                    <button matChipRemove [attr.aria-label]="'remove ' + teamMember.displayName">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                }
              }
              <input
                #teamMemberInput
                [placeholder]="'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.TEAM_MEMBER_PLACEHOLDER' | translate"
                [formControl]="teamMemberCtrl"
                [matChipInputFor]="teamMemberChipGrid"
                [matAutocomplete]="auto"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addTeamMemberFromInput($event)"
              />
            </mat-chip-grid>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedTeamMember($event)">
              @for (teamMember of filteredTeamMembers | async; track teamMember) {
                <mat-option [value]="teamMember" [disabled]="!teamMember.isConfigured || !teamMember.isConnected">
                  <div class="team-member-list">
                    <span>
                      {{ teamMember.displayName | titlecase }}
                    </span>
                    @if (!teamMember.isConfigured || !teamMember.isConnected) {
                      <mat-icon class="warn-icon">warning</mat-icon>
                    }
                  </div>
                </mat-option>
              }
            </mat-autocomplete>
            @if (
              teamMemberCtrl.touched &&
              selectedTeamMembers.length < 1 &&
              radioChoiceValue !== TeamEventMeetingType.MULTI_HOST
            ) {
              <glxy-error>
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBERS_VALIDATION_REQUIRED' | translate: { count: 'one' } }}
              </glxy-error>
            }
            @if (
              teamMemberCtrl.touched &&
              selectedTeamMembers.length < 2 &&
              radioChoiceValue === TeamEventMeetingType.MULTI_HOST &&
              (isSessionEventType$ | async) === false
            ) {
              <glxy-error>
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBERS_VALIDATION_REQUIRED' | translate: { count: 'two' } }}
              </glxy-error>
            }
            @if (
              teamMemberCtrl.touched &&
              selectedTeamMembers.length < 1 &&
              radioChoiceControl.value === TeamEventMeetingType.MULTI_HOST &&
              (isSessionEventType$ | async) === true
            ) {
              <glxy-error>
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBERS_VALIDATION_REQUIRED' | translate: { count: 'one' } }}
              </glxy-error>
            }
            @if (
              teamMemberCtrl.touched &&
              selectedTeamMembers.length > 5 &&
              radioChoiceValue === TeamEventMeetingType.MULTI_HOST
            ) {
              <glxy-error>
                {{
                  'MEETING_SCHEDULER.BOOKING_LINK.MAX_MULTI_HOST_TEAM_MEMBERS_VALIDATION_REQUIRED'
                    | translate: { count: 'five' }
                }}
              </glxy-error>
            }
            @if (teamMemberCtrl.touched && teamMemberCtrl.errors?.['invalidTeamMembers']) {
              <glxy-error>
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.INVALID_TEAM_MEMBERS_ERROR' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
        </div>
        <!-- Priority Assignment Drag and Delete Section -->
        @if (radioChoiceValue === TeamEventMeetingType.PRIORITY_ROUND_ROBIN) {
          <div class="priority-assignment-container">
            <div class="priority-team-members" cdkDropList (cdkDropListDropped)="onTeamMemberPriorityDrop($event)">
              @for (teamMember of selectedTeamMembers; track trackByTeamMemberId(i, teamMember); let i = $index) {
                <div class="priority-team-member-item" cdkDrag [cdkDragData]="teamMember">
                  <mat-icon class="drag-handle">drag_indicator</mat-icon>
                  <span class="member-name">{{ teamMember.displayName | titlecase }}</span>
                  <mat-icon class="delete-button" (click)="onTeamMemberPriorityDelete(i)">delete_outline</mat-icon>
                </div>
              }
            </div>
          </div>
        }
        <div class="warning-spacing"></div>
        @if ((showAlert$ | async) === true) {
          <glxy-alert type="warning">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBER.INDICATOR' | translate }}
          </glxy-alert>
        }
      </form>
    </mat-expansion-panel>
  }

  @if ((!isUpdate || (loading$ | async) === false) && (isSessionEventType$ | async) === false) {
    <mat-expansion-panel
      data-testid="availability-selection-panel"
      class="settings-card day-card"
      expanded="{{ isMultiHostMeetingType }}"
    >
      <mat-expansion-panel-header class="expansion-header">
        <div class="title-description">
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.TITLE' | translate }}
          </mat-panel-title>
          <mat-panel-description class="Availability-card-description">
            {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.PROMPT' | translate }}
          </mat-panel-description>
        </div>
      </mat-expansion-panel-header>
      <div>
        <meeting-scheduler-settings-advanced-availability-card
          [eventTypeId]="meetingId"
          [timezone]="timezone"
          [selectedHosts]="selectedTeamMembers"
          [hostAvailability]="hostAvailability$"
          [isMultiHost]="isMultiHostMeetingType"
          [meetingDuration]="meetingDuration"
          [displayAvailabilitySelectionError]="displayAvailabilitySelectionError"
          [displayAvailabilitySelectionSlotError]="displayAvailabilitySelectionSlotError"
          [displayAvailabilityInsufficientDurationError]="displayAvailabilityInsufficientDurationError"
          (hasSelectedAvailability)="hasSelectedAvailability($event)"
          (selectedAvailability)="updatedSelectedAvailabilityValue($event)"
        ></meeting-scheduler-settings-advanced-availability-card>
      </div>
    </mat-expansion-panel>
  }
  @if (
    (!isUpdate || (loading$ | async) === false) &&
    !showScheduleAccordion &&
    ((featureSMSEnabled$ | async) === false || context !== 'SMB' || !isSmsCountry || !showSmsFeaturePanel)
  ) {
    <mat-expansion-panel class="settings-card" expanded="false">
      <mat-expansion-panel-header class="expansion-header">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="settings-card-description">
          {{ questionsCardDescription }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <glxy-form-field>
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.DEFAULT.QUESTIONS_SECTION' | translate }}
        </glxy-label>
      </glxy-form-field>
      <mat-accordion class="deafult-question-accordion">
        <mat-expansion-panel disabled>
          <mat-expansion-panel-header class="custom-panel-header">
            <mat-panel-title class="default-form-field-title">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_FIRST_NAME' | translate }}
            </mat-panel-title>
            <mat-panel-description class="default-form-field-description">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_TEXT' | translate }}
            </mat-panel-description>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
        <mat-expansion-panel disabled>
          <mat-expansion-panel-header class="custom-panel-header">
            <mat-panel-title class="default-form-field-title nowrap">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_LAST_NAME' | translate }}
            </mat-panel-title>
            <mat-panel-description class="default-form-field-description">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_TEXT' | translate }}
            </mat-panel-description>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
        <mat-expansion-panel disabled>
          <mat-expansion-panel-header class="custom-panel-header">
            <mat-panel-title class="default-form-field-title nowrap">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_EMAIL' | translate }}
            </mat-panel-title>
            <mat-panel-description class="default-form-field-description">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_EMAIL' | translate }}
            </mat-panel-description>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
        <mat-expansion-panel disabled>
          <mat-expansion-panel-header class="custom-panel-header">
            <mat-panel-title class="default-form-field-title nowrap">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_PHONE_NUMBER' | translate }}
            </mat-panel-title>
            <mat-panel-description class="default-form-field-description">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_PHONE_NUMBER' | translate }}
            </mat-panel-description>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
        <mat-expansion-panel disabled>
          <mat-expansion-panel-header class="custom-panel-header">
            <mat-panel-title class="default-form-field-title nowrap">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_COMMENTS' | translate }}
            </mat-panel-title>
            <mat-panel-description class="default-form-field-description">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_TEXT_AREA' | translate }}
            </mat-panel-description>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
      </mat-accordion>

      <glxy-form-field>
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.Custom.QUESTIONS_SECTION' | translate }}
        </glxy-label>
      </glxy-form-field>
      <mat-accordion
        #accordion="matAccordion"
        cdkDropList
        (cdkDropListDropped)="changeFieldOrder($event)"
        multi="true"
        class="drag-boundary"
      >
        @for (field of customFieldsControl['controls']; track field; let i = $index) {
          <mat-expansion-panel [formGroup]="field" cdkDrag cdkDragLockAxis="y" cdkDragBoundary=".drag-boundary">
            <mat-expansion-panel-header>
              <mat-panel-title class="form-field-title">
                <mat-icon cdkDragHandle class="handle-icon">drag_indicator</mat-icon>
                <div class="form-field-title-text">
                  <span>{{ field.value.label }}{{ field.value.required ? '*' : '' }}</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="form-field-content">
              <div class="form-field-options">
                <mat-checkbox formControlName="required">
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.REQUIRED' | translate }}
                </mat-checkbox>
              </div>
              <mat-form-field appearance="outline" class="form-field-spacing">
                <mat-label>
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE' | translate }}
                </mat-label>
                <mat-select required formControlName="type">
                  @for (fieldType of fieldTypeKeys; track fieldType) {
                    <mat-option [value]="fieldType">
                      {{ describeFieldType(fieldType) }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.LABEL' | translate }}
                </mat-label>
                <input matInput required formControlName="label" />
                @if (field.controls.label.invalid) {
                  <mat-error>
                    {{ fieldLabelErrorMessage(field.controls.label.value) }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <mat-action-row>
              <button mat-stroked-button color="warn" (click)="deleteField(i)">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DELETE' | translate }}
              </button>
            </mat-action-row>
          </mat-expansion-panel>
        }
        <div class="button-container">
          <button
            mat-stroked-button
            color="primary"
            class="add-field-button"
            [class.active]="!customFieldsControl.invalid"
            [disabled]="customFieldsControl.invalid"
            (click)="addFormField()"
          >
            <span class="plus-sign">+</span> {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.ADD' | translate }}
          </button>
        </div>
      </mat-accordion>

      @if (customFieldsControl.invalid) {
        <div class="custom-fields-errors">
          @if (fieldsHaveError('noDuplicates')) {
            <mat-error>
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.ERROR_DUPLICATES' | translate }}
            </mat-error>
          }
        </div>
      }
    </mat-expansion-panel>
  }
  @if ((!isUpdate || (loading$ | async) === false) && !showScheduleAccordion && showSmsPanelSection) {
    <mat-expansion-panel class="settings-card" expanded="false">
      <mat-expansion-panel-header class="expansion-header">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="settings-card-description">
          {{ questionsCardDescription }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <glxy-form-field>
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.DEFAULT.QUESTIONS_SECTION' | translate }}
        </glxy-label>
      </glxy-form-field>
      <form [formGroup]="form">
        <mat-accordion class="deafult-question-accordion">
          <mat-expansion-panel disabled>
            <mat-expansion-panel-header class="custom-panel-header">
              <mat-panel-title class="default-form-field-title">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_FIRST_NAME' | translate }}
              </mat-panel-title>
              <mat-panel-description class="default-form-field-description">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_TEXT' | translate }}
              </mat-panel-description>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
          <mat-expansion-panel disabled>
            <mat-expansion-panel-header class="custom-panel-header">
              <mat-panel-title class="default-form-field-title nowrap">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_LAST_NAME' | translate }}
              </mat-panel-title>
              <mat-panel-description class="default-form-field-description">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_TEXT' | translate }}
              </mat-panel-description>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
          <mat-expansion-panel disabled class="default-field-panel">
            <mat-expansion-panel-header class="custom-panel-header">
              <mat-panel-title class="default-form-field-title nowrap">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_EMAIL' | translate }}
                @if (showEmailBadge) {
                  <glxy-badge [color]="'green'" class="field-badge">
                    {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_EMAIL_CONFIRMATION' | translate }}
                  </glxy-badge>
                }
              </mat-panel-title>
              <mat-panel-description class="default-form-field-description">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_EMAIL' | translate }}
              </mat-panel-description>
              <div class="toggle-space default-field-toggle">
                <mat-slide-toggle formControlName="enableEmailField" (click)="$event.stopPropagation()" color="primary">
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.REQUIRED' | translate }}
                </mat-slide-toggle>
              </div>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
          <mat-expansion-panel disabled class="default-field-panel">
            <mat-expansion-panel-header class="custom-panel-header">
              <mat-panel-title class="default-form-field-title nowrap">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_PHONE_NUMBER' | translate }}
                @if (showPhoneBadge) {
                  <glxy-badge [color]="'green'" class="field-badge">
                    {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.PHONE_CONFIRMATION' | translate }}
                  </glxy-badge>
                }
                @if (showSmsRegisterButton) {
                  @if (canSendSmsReason === CanSendReason.CAN_SEND_REASON_A2P_REGISTRATION_IN_PROGRESS) {
                    <glxy-badge [color]="'blue'" class="field-badge">
                      {{ 'MEETING_SCHEDULER.BOOKING_LINK.SMS_REGISTRATION.BADGE_IN_PROGRESS' | translate }}
                    </glxy-badge>
                  } @else if (canSendSmsReason === CanSendReason.CAN_SEND_REASON_A2P_REGISTRATION_REJECTED) {
                    <glxy-badge [color]="'red'" class="field-badge">
                      {{ 'MEETING_SCHEDULER.BOOKING_LINK.SMS_REGISTRATION.BADGE_REJECTED' | translate }}
                    </glxy-badge>
                  } @else {
                    <glxy-badge [color]="'yellow'" class="field-badge">
                      {{ 'MEETING_SCHEDULER.BOOKING_LINK.SMS_REGISTRATION.BADGE' | translate }}
                    </glxy-badge>
                  }
                }
              </mat-panel-title>
              <mat-panel-description class="default-form-field-description">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_PHONE_NUMBER' | translate }}
              </mat-panel-description>
              <div class="toggle-space default-field-toggle">
                @if (canSendSms) {
                  <mat-slide-toggle
                    formControlName="enablePhoneNumberField"
                    (click)="$event.stopPropagation()"
                    color="primary"
                  >
                    {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.REQUIRED' | translate }}
                  </mat-slide-toggle>
                }
                @if (showSmsRegisterButton) {
                  <button
                    mat-flat-button
                    color="primary"
                    [disabled]="canSendSmsReason === CanSendReason.CAN_SEND_REASON_A2P_REGISTRATION_IN_PROGRESS"
                    (click)="$event.stopPropagation(); openRegisterConfirmationModal()"
                  >
                    {{ 'MEETING_SCHEDULER.BOOKING_LINK.SMS_REGISTRATION.REGISTER' | translate }}
                  </button>
                }
                @if (showSmsActivateButton) {
                  <button
                    mat-flat-button
                    color="primary"
                    (click)="$event.stopPropagation(); openRegisterConfirmationModal(true)"
                  >
                    {{ 'MEETING_SCHEDULER.BOOKING_LINK.SMS_REGISTRATION.ACTIVATE' | translate }}
                  </button>
                }
              </div>
            </mat-expansion-panel-header>
          </mat-expansion-panel>

          <!-- Show warning when no fields are required and canSendSms is true -->
          @if (canSendSms && areNoFieldsRequired) {
            <glxy-alert type="warning" class="channel-warning-alert">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.WARNING_MESSAGE' | translate }}
            </glxy-alert>
          }

          <!-- Show channel selection when both fields are required -->
          @if (areBothFieldsRequired) {
            <mat-expansion-panel disabled class="default-field-panel channel-selection-panel">
              <mat-expansion-panel-header class="custom-panel-header">
                <mat-panel-title class="default-form-field-title channel-question-title">
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.CHANNEL_QUESTION' | translate }}
                </mat-panel-title>
                <mat-panel-description class="default-form-field-description channel-buttons">
                  <glxy-button-group class="inline-button-group">
                    <button
                      mat-stroked-button
                      type="button"
                      [class.selected]="notificationTypeControl?.value === NotificationType.SMS"
                      (click)="notificationTypeControl?.setValue(NotificationType.SMS)"
                    >
                      <mat-icon>phone_iphone</mat-icon>
                      {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.PHONE' | translate }}
                    </button>
                    <button
                      mat-stroked-button
                      type="button"
                      [class.selected]="notificationTypeControl?.value === NotificationType.EMAIL"
                      (click)="notificationTypeControl?.setValue(NotificationType.EMAIL)"
                    >
                      <mat-icon>mail_outline</mat-icon>
                      {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.EMAIL' | translate }}
                    </button>
                  </glxy-button-group>
                </mat-panel-description>
              </mat-expansion-panel-header>
            </mat-expansion-panel>
          }

          <mat-expansion-panel disabled>
            <mat-expansion-panel-header class="custom-panel-header">
              <mat-panel-title class="default-form-field-title nowrap">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_COMMENTS' | translate }}
              </mat-panel-title>
              <mat-panel-description class="default-form-field-description">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_TEXT_AREA' | translate }}
              </mat-panel-description>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        </mat-accordion>
      </form>

      <glxy-form-field>
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.Custom.QUESTIONS_SECTION' | translate }}
        </glxy-label>
      </glxy-form-field>
      <mat-accordion
        #accordion="matAccordion"
        cdkDropList
        (cdkDropListDropped)="changeFieldOrder($event)"
        multi="true"
        class="drag-boundary"
      >
        @for (field of customFieldsControl['controls']; track field; let i = $index) {
          <mat-expansion-panel [formGroup]="field" cdkDrag cdkDragLockAxis="y" cdkDragBoundary=".drag-boundary">
            <mat-expansion-panel-header>
              <mat-panel-title class="form-field-title">
                <mat-icon cdkDragHandle class="handle-icon">drag_indicator</mat-icon>
                <div class="form-field-title-text">
                  <span>{{ field.value.label }}{{ field.value.required ? '*' : '' }}</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="form-field-content">
              <div class="form-field-options">
                <mat-checkbox formControlName="required">
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.REQUIRED' | translate }}
                </mat-checkbox>
              </div>
              <mat-form-field appearance="outline" class="form-field-spacing">
                <mat-label>
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE' | translate }}
                </mat-label>
                <mat-select required formControlName="type">
                  @for (fieldType of fieldTypeKeys; track fieldType) {
                    <mat-option [value]="fieldType">
                      {{ describeFieldType(fieldType) }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.LABEL' | translate }}
                </mat-label>
                <input matInput required formControlName="label" />
                @if (field.controls.label.invalid) {
                  <mat-error>
                    {{ fieldLabelErrorMessage(field.controls.label.value) }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <mat-action-row>
              <button mat-stroked-button color="warn" (click)="deleteField(i)">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DELETE' | translate }}
              </button>
            </mat-action-row>
          </mat-expansion-panel>
        }
        <div class="button-container">
          <button
            mat-stroked-button
            color="primary"
            class="add-field-button"
            [class.active]="!customFieldsControl.invalid"
            [disabled]="customFieldsControl.invalid"
            (click)="addFormField()"
          >
            <span class="plus-sign">+</span> {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.ADD' | translate }}
          </button>
        </div>
      </mat-accordion>

      @if (customFieldsControl.invalid) {
        <div class="custom-fields-errors">
          @if (fieldsHaveError('noDuplicates')) {
            <mat-error>
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.ERROR_DUPLICATES' | translate }}
            </mat-error>
          }
        </div>
      }
    </mat-expansion-panel>
  }

  @if ((!isUpdate || (loading$ | async) === false) && (isSessionEventType$ | async) === false) {
    <mat-expansion-panel class="settings-card" expanded="false">
      <mat-expansion-panel-header class="expansion-header">
        <div class="title-description">
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CUSTOMIZE_INVITATION_EMAIL.TITLE' | translate }}
          </mat-panel-title>
          <mat-panel-description>
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CUSTOMIZE_INVITATION_EMAIL.DESCRIPTION' | translate }}
          </mat-panel-description>
        </div>
      </mat-expansion-panel-header>
      <form [formGroup]="form">
        <glxy-form-field>
          <glxy-label>
            {{ 'MEETING_SCHEDULER.CUSTOMIZE_INVITATION_EMAIL.SUBJECT' | translate }}
          </glxy-label>
          <input
            matInput
            formControlName="emailSubject"
            [placeholder]="
              'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CUSTOMIZE_INVITATION_EMAIL_SUBJECT.PLACEHOLDER' | translate
            "
          />
        </glxy-form-field>
        <glxy-form-field appearance="outline" class="fullwidth">
          <glxy-label>
            {{ 'MEETING_SCHEDULER.CUSTOMIZE_INVITATION_EMAIL.DESCRIPTION' | translate }}
          </glxy-label>
          <textarea
            matAutosizeMinRows="4"
            matInput
            matTextareaAutosize
            formControlName="emailDescription"
            [placeholder]="
              'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CUSTOMIZE_INVITATION_EMAIL_DESCRIPTION.PLACEHOLDER'
                | translate
            "
          ></textarea>
        </glxy-form-field>
      </form>
    </mat-expansion-panel>
  }

  @if ((!isUpdate || (loading$ | async) === false) && (isSessionEventType$ | async) === false) {
    <mat-expansion-panel class="settings-card" expanded="false">
      <mat-expansion-panel-header class="expansion-header">
        <div class="title-description">
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.AVAILABILITY_INCREMENT.TITLE' | translate }}
          </mat-panel-title>
          <mat-panel-description class="availability-card-description">
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.AVAILABILITY_INCREMENT.DESCRIPTION' | translate }}
          </mat-panel-description>
        </div>
      </mat-expansion-panel-header>
      <form [formGroup]="form">
        <mat-button-toggle-group formControlName="availabilityIncrement" [value]="null">
          @for (option of increments; track option) {
            <mat-button-toggle class="toggle-increments" [value]="option.seconds">
              {{ option.label }}
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </form>
      <glxy-form-field class="availability-hint">
        <glxy-label>
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.AVAILABILITY_INCREMENT.HINT' | translate }}
        </glxy-label>
      </glxy-form-field>
    </mat-expansion-panel>
  }

  @if ((!isUpdate || (loading$ | async) === false) && !showScheduleAccordion) {
    <mat-expansion-panel
      class="settings-card"
      [expanded]="isMultiHostMeetingType && (isSessionEventType$ | async) === false"
    >
      <mat-expansion-panel-header class="expansion-header">
        <div class="title-description">
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION_BEFORE.TITLE' | translate }}
          </mat-panel-title>
          <mat-panel-description class="Availability-card-description">
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION_BEFORE.DESCRIPTION' | translate }}
          </mat-panel-description>
        </div>
      </mat-expansion-panel-header>
      <form [formGroup]="form">
        <mat-button-toggle-group formControlName="bufferDurationBeforeMeeting">
          @for (buffer of buffers; track buffer) {
            <mat-button-toggle class="toggle-increments" [value]="buffer.seconds">
              {{ buffer.label }}
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </form>
      <glxy-form-field class="availability-hint">
        <glxy-label>
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION.HINT' | translate }}
        </glxy-label>
      </glxy-form-field>
    </mat-expansion-panel>
  }

  @if ((!isUpdate || (loading$ | async) === false) && !showScheduleAccordion) {
    <mat-expansion-panel
      class="settings-card"
      [expanded]="isMultiHostMeetingType && (isSessionEventType$ | async) === false"
    >
      <mat-expansion-panel-header class="expansion-header">
        <div class="title-description">
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION.TITLE' | translate }}
          </mat-panel-title>
          <mat-panel-description class="availability-card-description">
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION.DESCRIPTION' | translate }}
          </mat-panel-description>
        </div>
      </mat-expansion-panel-header>
      <form [formGroup]="form">
        <mat-button-toggle-group formControlName="bufferDurationAfterMeeting">
          @for (buffer of buffers; track buffer) {
            <mat-button-toggle class="toggle-increments" [value]="buffer.seconds">
              {{ buffer.label }}
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </form>
      <glxy-form-field class="availability-hint">
        <glxy-label>
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION.HINT' | translate }}
        </glxy-label>
      </glxy-form-field>
    </mat-expansion-panel>
  }

  @if ((!isUpdate || (loading$ | async) === false) && (isSessionEventType$ | async) === false) {
    <mat-expansion-panel class="settings-card" expanded="false">
      <mat-expansion-panel-header class="expansion-header">
        <div class="title-description">
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.NOTICE_TIME.TITLE' | translate }}
          </mat-panel-title>
          <mat-panel-description class="availability-card-description">
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.NOTICE_TIME.DESCRIPTION' | translate }}
          </mat-panel-description>
        </div>
      </mat-expansion-panel-header>
      <form [formGroup]="form">
        <mat-button-toggle-group formControlName="noticeTime">
          @for (advNotice of advanceNotice; track advNotice) {
            <mat-button-toggle class="toggle-increments" [value]="advNotice.seconds">
              {{ advNotice.label }}
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </form>
    </mat-expansion-panel>
  }
  @if (isUpdate && (loading$ | async) === false && (isSessionEventType$ | async) === false) {
    <mat-expansion-panel class="settings-card day-card" expanded="false">
      <mat-expansion-panel-header class="expansion-header">
        <div class="title-description">
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ADD_TO_WEBSITE.TITLE' | translate }}
          </mat-panel-title>
          <mat-panel-description class="availability-card-description">
            {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ADD_TO_WEBSITE.PROMPT' | translate }}
          </mat-panel-description>
        </div>
      </mat-expansion-panel-header>
      <div>
        <meeting-scheduler-settings-add-to-website-card
          [isUpdate]="isUpdate"
          [calendarId]="calendarId"
          [name]="eventTypeName"
          [id]="eventTypeId"
        ></meeting-scheduler-settings-add-to-website-card>
      </div>
    </mat-expansion-panel>
  }

  @if (
    (featureDateRangeEnabled$ | async) &&
    (!isUpdate || (loading$ | async) === false) &&
    (isSessionEventType$ | async) === false
  ) {
    <mat-expansion-panel class="settings-card day-card" expanded="false">
      <mat-expansion-panel-header class="expansion-header">
        <div class="title-description">
          <mat-panel-title class="settings-card-title">
            {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.DATE_RANGE.TITLE' | translate }}
          </mat-panel-title>
          <mat-panel-description class="availability-card-description">
            {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.DATE_RANGE.PROMPT' | translate }}
          </mat-panel-description>
        </div>
      </mat-expansion-panel-header>
      <form [formGroup]="form">
        <div class="range-type-section">
          <mat-radio-group formControlName="dateRangeType" class="range-type-group">
            <!-- Relative Date Range Option -->
            <div class="radio-option">
              <mat-radio-button [value]="DateRangeType.RELATIVE" class="radio-button">
                <div class="controls-inline">
                  <glxy-form-field class="value-field" hideRequiredLabel="true">
                    <input matInput type="number" formControlName="relativeValue" [min]="1" class="relative-input" />
                  </glxy-form-field>
                  <glxy-form-field class="unit-field" hideRequiredLabel="true">
                    <mat-select formControlName="relativeUnit" class="unit-select">
                      @for (unit of timeUnits; track unit) {
                        <mat-option [value]="unit.value">
                          {{ unit.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </glxy-form-field>
                  <span class="suffix-text">into the future</span>
                </div>
              </mat-radio-button>
              <!-- Error messages for relative option -->
              @if (isRelativeMode) {
                <div class="radio-option-errors">
                  @if (
                    relativeValueControl?.invalid && (relativeValueControl?.dirty || relativeValueControl?.touched)
                  ) {
                    <glxy-error>
                      {{ relativeValueError }}
                    </glxy-error>
                  }
                  @if (relativeUnitControl?.invalid && (relativeUnitControl?.dirty || relativeUnitControl?.touched)) {
                    <glxy-error> Unit is required </glxy-error>
                  }
                </div>
              }
            </div>
            <!-- Custom Date Range Option -->
            <div class="radio-option">
              <mat-radio-button [value]="DateRangeType.CUSTOM" class="radio-button">
                <div class="controls-inline">
                  <glxy-form-field class="date-field" hideRequiredLabel="true">
                    <input
                      matInput
                      [matDatepicker]="startPicker"
                      formControlName="startDate"
                      placeholder="Select start date"
                      [min]="today"
                      readonly
                    />
                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                  </glxy-form-field>
                  <span class="date-label">to</span>
                  <glxy-form-field class="date-field" hideRequiredLabel="true">
                    <input
                      matInput
                      [matDatepicker]="endPicker"
                      formControlName="endDate"
                      placeholder="Select end date"
                      [min]="today"
                      readonly
                    />
                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                  </glxy-form-field>
                </div>
              </mat-radio-button>
              <!-- Error messages for custom option -->
              @if (isCustomMode) {
                <div class="radio-option-errors">
                  @if (startDateControl?.invalid && (startDateControl?.dirty || startDateControl?.touched)) {
                    <glxy-error>
                      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ALERTS.DATE_RANGE.START_DATE_REQUIRED' | translate }}
                    </glxy-error>
                  }
                  @if (endDateControl?.invalid && (endDateControl?.dirty || endDateControl?.touched)) {
                    <glxy-error>
                      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ALERTS.DATE_RANGE.END_DATE_REQUIRED' | translate }}
                    </glxy-error>
                  }
                  @if (hasDateRangeError) {
                    <glxy-error>
                      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ALERTS.DATE_RANGE.INVALID_RANGE' | translate }}
                    </glxy-error>
                  }
                </div>
              }
            </div>
          </mat-radio-group>
        </div>
      </form>
    </mat-expansion-panel>
  }

  <glxy-sticky-footer [rightAligned]="true">
    <!-- Show both Create and Schedule buttons for session event types when not in update mode and not showing schedule accordion -->
    @if ((isSessionEventType$ | async) === true && !isUpdate && !showScheduleAccordion) {
      <div class="button-group">
        <button mat-stroked-button type="submit" [disabled]="saving$ | async" (click)="createOrUpdateMeetingType()">
          <span [class.hidden-text]="savingAction === 'create' && (saving$ | async)">
            {{ buttonText }}
          </span>
          @if (savingAction === 'create' && (saving$ | async)) {
            <div class="btn-spinner-container">
              <mat-spinner diameter="20"></mat-spinner>
            </div>
          }
        </button>
        <button
          mat-flat-button
          color="primary"
          type="button"
          [disabled]="saving$ | async"
          (click)="createAndSchedule()"
          class="schedule-button"
        >
          <span [class.hidden-text]="savingAction === 'schedule' && (saving$ | async)">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.SCHEDULE_SESSION_NOW' | translate }}
          </span>
          @if (savingAction === 'schedule' && (saving$ | async)) {
            <div class="btn-spinner-container">
              <mat-spinner diameter="20"></mat-spinner>
            </div>
          }
        </button>
      </div>
    } @else {
      <button
        mat-flat-button
        color="primary"
        type="submit"
        [disabled]="saving$ | async"
        (click)="createOrUpdateMeetingType()"
      >
        <span [class.hidden-text]="saving$ | async">
          {{ buttonText }}
        </span>
        @if (saving$ | async) {
          <div class="btn-spinner-container">
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        }
      </button>
    }

    <!-- Default single button for all other cases -->
  </glxy-sticky-footer>
</div>
